const url = window.AppENV.mercadopagoApi;

export const getPlans = async (token) => {
  const request = await fetch(`${url}/products/motorplay`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  const response = await request.json();
  return response;
};

export const createSubscription = async (token, data) => {
  return fetch(`${url}/motorplay/subscribe`, {
    body: JSON.stringify(data),
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
    method: 'POST',
  }).then(async (resp) => {
    const body = await resp.json();
    if(resp.ok) {
      return body;
    }
    
    throw new Error(body.message);
  });
};

export const redeemCoupon = async (token, data) => {
  return fetch(`${url}/motorplay/coupon`, {
    body: JSON.stringify(data),
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
    method: 'POST',
  }).then(async (resp) => {
    const body = await resp.json();
    if(resp.ok) {
      return body;
    }
    
    throw new Error(body.message);
  });
};

export const getSubscription = async (token) => {
  const request = await fetch(`${url}/subscription`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  const response = await request.json();
  return response;
};

export const cancelSubscription = async (token, subscriptionId) => {
  return fetch(`${url}/subscription/${subscriptionId}`, {
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
    method: 'DELETE',
  }).then(async (resp) => {
    const body = await resp.json();
    if(resp.ok) {
      return body;
    }
    
    throw new Error(body.message);
  });
};